module.exports = __webpack_public_path__ + "static/ML_AC_differentiators-4016845355f6645d061834218b952789.svg";